/** @typedef {import('@utahdts/utah-design-system').BannerPlacement} BannerPlacement */

/**
 * Positions for banners
 * @enum {BannerPlacement}
 */
export const BANNER_PLACEMENT = {
  INLINE: /** @type {BannerPlacement} */ ('inline'),
  BOTTOM_LEFT: /** @type {BannerPlacement} */ ('bottom-left'),
  BOTTOM_RIGHT: /** @type {BannerPlacement} */ ('bottom-right'),
  BOTTOM_MIDDLE: /** @type {BannerPlacement} */ ('bottom'),
  TOP_LEFT: /** @type {BannerPlacement} */ ('top-left'),
  TOP_RIGHT: /** @type {BannerPlacement} */ ('top-right'),
  TOP_MIDDLE: /** @type {BannerPlacement} */ ('top'),
};
